
export const styleBox = {
  "& .MuiTextField-root": { m: 1 },
  p: 3,
  mx: 2,
  mb: 3,
  mt: 2,
  alignItems: "center",
  borderRadius: 3,
  bgcolor: "background.paper",
  border: "1px solid",
  borderColor: "divider",
};